export const constructPointLayerDefinition = {
    geometryType: 'esriGeometryPoint',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 115.71960466027735,
        ymin: -33.25710132151562,
        xmax: 122.83245485185546,
        ymax: -24.637873586726585,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: false
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'constructtype',
            type: 'esriFieldTypeInteger',
            alias: 'constructtype',
            editable: true,
            nullable: true
        },
        {
            name: 'constructfromlineid',
            type: 'esriFieldTypeInteger',
            alias: 'constructfromlineid',
            editable: true,
            nullable: true
        },
        {
            name: 'constructtolineid',
            type: 'esriFieldTypeInteger',
            alias: 'constructtolineid',
            editable: true,
            nullable: true
        },
        {
            name: 'sourcefromlineid',
            type: 'esriFieldTypeInteger',
            alias: 'sourcefromlineid',
            editable: true,
            nullable: true
        },
        {
            name: 'sourcetolineid',
            type: 'esriFieldTypeInteger',
            alias: 'sourcetolineid',
            editable: true,
            nullable: true
        },
        {
            name: 'sourcelineids',
            type: 'esriFieldTypeString',
            alias: 'sourcelineids',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'markplacement',
            type: 'esriFieldTypeString',
            alias: 'markplacement',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'marktype',
            type: 'esriFieldTypeInteger',
            alias: 'marktype',
            editable: true,
            nullable: true
        },
        {
            name: 'markstatus',
            type: 'esriFieldTypeString',
            alias: 'markstatus',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'installlocation',
            type: 'esriFieldTypeString',
            alias: 'installlocation',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'fieldrecordreference',
            type: 'esriFieldTypeString',
            alias: 'fieldrecordreference',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'visible',
            type: 'esriFieldTypeString',
            alias: 'visible',
            editable: true,
            nullable: true,
            length: 5
        },
        {
            name: 'hiddenonenlargements',
            type: 'esriFieldTypeString',
            alias: 'hiddenOnEnlargements',
            editable: true,
            nullable: true,
            length: 1024
        }
    ]
};
